/**
 * Глобальный скрипт, определяющий функцию getZone в window
 * getZone - функция определения региона для prod и dev окружений
 * Экспортируется как строка для вставки в inline script
 */
export const globalGetZoneScript = `
    window.__getZone = function getZone() {
        var hostname = window.location.hostname;
        var zones = ['ru', 'kz', 'am', 'ge', 'tg', 'com'];

        var devMatch = hostname.match(/dev-2gis-([a-z]+)/);

        if (devMatch && zones.includes(devMatch[1])) {
            return devMatch[1];
        }

        var domainZone = hostname.split('.').pop();
        
        if (zones.includes(domainZone)) {
            return domainZone;
        }

        return 'ru';
    };
`;
